<template>
  <div>
    <Modal v-model="modal" width="360" footer-hide :styles="{top: '20%'}" class="error-modal">
      <div style="text-align:center">
        <img src="~assets/img/onlineblock/attentionmulticolor.png" alt />
        <p>确定要删除标签吗？</p>
        <div class="btngroup">
          <Button class="btn" type="default" @click="modal = false">取消</Button>
          <Button class="btn" type="error" @click="deleteConfirm">确认</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { error } from 'util'
import { resolve } from 'url'
import { reject } from 'q'
export default {
  name: "ModalLabelDelete",
  props: ["deleteStatus", "selectArr"],
  data(){
    return {
      labelidarr:[]
    }
  },
  computed: {
    modal: {
      get () {
        return this.deleteStatus
      },
      set (val) {
        this.$emit("update:deleteStatus", val)
      }
    }
  },
  methods: {
    deleteConfirm () {
      this.labelidarr= []
      this.selectArr.forEach(i => {
        this.labelidarr.push(i.labelid)
      })
        this.$axios.changememlabel({ labelid: this.labelidarr, type: "0" })
          .then(res => {
            if(res.status == 1) {
              this.modal = false
              this.$emit("getlabel")
            }
          })
          .catch(err => console.error(err))
    },
  }
}
</script>